import * as react from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const titleMap = {
  "/": "Soyara Rental Couture - Rent Wedding Dresses, Gowns & Lehengas in Pune | Ravet, PCMC, Pimpri-Chinchwad",
  "/product_list/1": "Men Collection - Soyara Rental Couture",
  "/product_list/2": "Women Collection - Soyara Rental Couture",
  "/product_list/3": "Jewellery Collection - Soyara Rental Couture",
  "/product_list/4": "Boy-Kids Collection - Soyara Rental Couture",
  "/product_list/5": "Girl-Kids Collection - Soyara Rental Couture",
  "/faq": "FAQs - Soyara Rental Couture",
  "/contact": "Contact Us - Soyara Rental Couture",
  "/about": "About Us - Soyara Rental Couture",
};

export default function TitleManager() {
  const location = useLocation();
  useEffect(() => {
    let title;

    // ✅ Dynamic route check
    if (location.pathname.startsWith("/product_details/")) {
      title = "Product Details – Soyara Rental Couture";
    } else {
      title =
        titleMap[location.pathname] ||
        "Soyara Rental Couture - Rent Wedding Dresses, Gowns & Lehengas in Pune | Ravet, PCMC, Pimpri-Chinchwad";
    }

    document.title = title;
  }, [location]);
  return null;
}
